import { Skeleton } from "@chakra-ui/react";

export default function LoadingButton() {
  return <Skeleton h={10} rounded="md" w={32} />;
}
